/**
 * Created by Andrey Popov on 29.11.22
 */

const Campaign = function (unit) { 
    UnitComponent.call(this, unit);

    if (cleverapps.environment.isAdministratorScene()) {
        return;
    }

    if (unit.stage < Families[unit.code].units.length - 1) {
        this.addQuest();
    }
};

Campaign.prototype = Object.create(UnitComponent.prototype);
Campaign.prototype.constructor = Campaign;

Campaign.prototype.addQuest = function () {
    const id = Unit.GetKey(this.unit);

    const questsData = bundles[`quests_${cleverapps.meta.selectedLocationId()}`].jsons.quests_json.resolve().getJson();

    const questTemplate = questsData[id];

    if (!questTemplate) {
        return;
    }

    const questConfig = {
        trigger: {
            unit: { code: this.unit.code, stage: this.unit.stage }
        },
        campaign: true,
        quest: {
            id: Unit.GetKey(this.unit),
            type: Map2d.SPAWN,
            unit: { code: this.unit.code, stage: this.unit.stage + 1 }
        }
    };
    Quests.appendJsonDataToQuest(questConfig, questTemplate);
    QuestsConfig[cleverapps.meta.selectedLocationId()][Unit.GetKey(this.unit)] = questConfig;
};

Campaign.prototype.handleRemove = function () {
    delete QuestsConfig[cleverapps.meta.selectedLocationId()][Unit.GetKey(this.unit)];
};

Campaign.getCampaignQuestIcon = function (unit) {
    const recipes = CustomerRecipes[cleverapps.meta.selectedLocationId()][Unit.GetKey({
        code: unit.code,
        stage: unit.stage - 1
    })];
    const recipe = recipes && recipes[0];
    const unitData = Families[unit.code] && Families[unit.code].units[unit.stage];
    if (recipe && !(unitData && unitData.campaignQuestOwnIcon)) {
        const ingredient = recipe.ingredients.filter((ingredient) => ingredient.type === "campaignorder")[0];
        if (ingredient) {
            unit = {
                code: cleverapps.unitsLibrary.listCodesByType(ingredient.type)[0],
                stage: ingredient.stage
            };
        }
    }

    const icon = cleverapps.skins.getSlot("campaignQuestIcon", unit);
    if (icon) {
        return icon;
    }

    return UnitView.getUnitImage(unit, { preferStatic: true });
};